/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React from 'react';
import { Alert } from 'react-bootstrap';

function WiseAlert({ text }) {
  return (
    <Alert key={'danger'} variant={'danger'}>
      <Flex>
        <FontAwesomeIcon icon="times-circle" size="3x" />
        <p className="mb-0 ms-3">{text}</p>
      </Flex>
    </Alert>
  );
}

export default WiseAlert;
